<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { useContactLaunchers } from '@hooks/support/contact-launchers.hook'

import amplitudeConfig from '@config/amplitude.json'
import { getContacts } from '@config/support'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'LinkWhatsApp',
})

const text = 'WhatsApp'
const contacts = getContacts()

const {
  openWhatsApp,
} = useContactLaunchers()

const setSubmit = (): void => {
  const options = {
    phone: contacts.whatsUpPhone,
    text: 'Support request',
  }
  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_whats_app',
    link_text: text,
    ...options,
  })
  openWhatsApp(options)
}
</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="whatsapp"
        size="md"
      />
    </template>
  </DropdownItem>
</template>
